var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOlimpica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 259.874,
    height: 36,
    viewBox: "0 0 259.874 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3942",
    "data-name": "Rect\\xE1ngulo 3942",
    width: 259.874,
    height: 36,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6772",
    "data-name": "Grupo 6772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6771",
    "data-name": "Grupo 6771",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9505",
    "data-name": "Trazado 9505",
    d: "M103.683,17.984c3.674-.062,4.436,2.132,3.826,4.2-.734,2.509-2.686,4.366-6.27,4.366-3.967,0-4.238-2.425-3.67-4.366a5.939,5.939,0,0,1,6.114-4.2m1.157-3.714c-7.867,0-14.149,3.1-15.549,7.872-1.517,5.168,2.923,8.123,10.859,8.123,7.484,0,14.135-2.913,15.649-8.08,1.176-4.009-1.928-7.914-10.959-7.914",
    transform: "translate(-28.702 -4.602)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9506",
    "data-name": "Trazado 9506",
    d: "M147.965,29.953l.865-2.971H137.806L141.258,15H133.23L128.9,29.953Z",
    transform: "translate(-41.571 -4.837)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9507",
    "data-name": "Trazado 9507",
    d: "M168.175,29.953,172.5,15h-8.027l-4.332,14.956Z",
    transform: "translate(-51.648 -4.837)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9508",
    "data-name": "Trazado 9508",
    d: "M234.811,21.762l.959-3.3h2.279c1.7,0,4.232.187,3.831,1.57-.371,1.282-1.864,1.732-3.734,1.732Zm-2.35,8.194,1.343-4.726h4.049c7.04,0,10.755-2.022,11.686-5.222.888-3.054-1.946-5.012-8.988-5.012h-11.8l-4.314,14.96Z",
    transform: "translate(-72.382 -4.836)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9509",
    "data-name": "Trazado 9509",
    d: "M269.038,29.963,273.527,15h-8.2l-4.319,14.962Z",
    transform: "translate(-84.177 -4.838)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9510",
    "data-name": "Trazado 9510",
    d: "M332.978,24.883h-5.232l4.157-5.335ZM323.7,29.949l1.534-1.965h8.25l.4,1.965h8.25l-4.606-14.94H329.1l-13.51,14.94Z",
    transform: "translate(-101.781 -4.841)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9511",
    "data-name": "Trazado 9511",
    d: "M306.435,20.41c.5-3.873-3.284-6.155-11.29-6.155-7.32,0-14,3.035-15.493,7.914-1.5,4.9,2.8,7.958,11.466,7.958,6.92,0,12.478-2.344,14.437-6.24h-8.265c-.768,1.446-2.42,2.556-5.187,2.556-4.368,0-4.559-1.989-3.912-4.1a6,6,0,0,1,6.189-4.4c2.691,0,4.128.9,3.9,2.471Z",
    transform: "translate(-90.095 -4.598)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9512",
    "data-name": "Trazado 9512",
    d: "M184.558,29.956l2.3-9.6,1.788,9.6H194l7.754-9.6-3.342,9.6h7.35l4.388-14.971h-9.872l-7.3,9.31-1.5-9.31h-9.871l-4.4,14.971Z",
    transform: "translate(-57.152 -4.833)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9513",
    "data-name": "Trazado 9513",
    d: "M47.42,31.672H42.048c-4.307-.374-6.847-.623-9.011-1.409C27.366,28.3,27.076,20.987,34.2,19.05c3.455-.946,10.289-4.034,6.806-8.5,7.563.931,12.4,3.349,15.137,6.06a2.125,2.125,0,0,0,0-1.559c9.612,2.712,13.6,16.623-8.717,16.623",
    transform: "translate(-9.293 -3.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9514",
    "data-name": "Trazado 9514",
    d: "M50.441,33.805c8.711-.667,11.377-4.432,9.676-8.469-.814-2.2-4.081-5.348-11.568-8.174,1.33,3.753-.368,5.581-4.9,6.63-6.792,1.128-6.829,6.593-3.506,8.287a12.279,12.279,0,0,0,4.891,1.726Z",
    transform: "translate(-12.251 -5.535)",
    fill: "#004c9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9515",
    "data-name": "Trazado 9515",
    d: "M52.481,36.69c6.692-1.281,8.725-7.308-.379-10.582.524,2.146-.57,3.319-4.04,4.007-4.288,1.124-4.7,5.518-.947,6.576Z",
    transform: "translate(-14.368 -8.42)",
    fill: "#d9000d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOlimpica);
export default __webpack_public_path__ + "static/media/logo-olimpica.ec4444b524060807ebcedd20fde180db.svg";
export { ForwardRef as ReactComponent };